// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2WgPH","inputWrap":"Table_inputWrap__2gVnn","col":"Table_col__1e3Hq","bmiTooltip":"Table_bmiTooltip__2lMk6"};